import { ContextApi } from "contexts/Localization/types";
import { FooterLinkType } from "./types";

export const footerLinks: (t: ContextApi['t']) => FooterLinkType[] = (t) => [
  {
    label: t('Sitemap'),
    items: [
      {
        label: t('Home'),
        href: "https://deblox.io/",
      },
      {
        label: t('IGO'),
        href: "https://deblox.io/igo",
      },
      {
        label: t('User'),
        href: "https://deblox.io/avatar",
      },
      {
        label: t('Games'),
        href: "https://deblox.io/game",
      },
    ],
  },
  {
    label: t('Services'),
    items: [
      {
        label: t('Product'),
        href: "https://docs.deblox.io/contact-us/customer-support",
      },
      {
        label: t('Resources'),
        href: "https://docs.deblox.io/get-started",
      },
      {
        label: t('Documentation'),
        href: "https://docs.deblox.io/",
      },
      {
        label: t('Support'),
        href: "https://docs.deblox.io/get-started",
      },
    ],
  }
];

